import {api} from "../resources"

export default {
    namespaced: true,
    state: {
        contractors: []
    },
    getters: {
        contractorsByPopularity: (state) => (type) => {
            return state.contractors
                .filter(i => i.type === type || i.type === 3)
                .sort((a, b) => b.popularity - a.popularity)
        }
    },
    actions: {
        getContractors({commit, rootState}) {
            const space_id = rootState.space.current_space.data.id;
            api.contractors.get({space_id, 'per-page': 500}).then(res => {
                if (res.body.success) {
                    commit('setContractors', res.body.data.rows);
                }
            })
        },
        createContractor({}, data) {
            //{space_id, title, type}
            return api.contractors.save(data);
        },
        updateContractor({}, data) {
            //{space_id, title, type}
            return api.contractors_id.update({id: data.id}, {...data});
        },
        archiveContractor({}, id) {
            //{space_id, title, type}
            return api.contractors_id.remove({id: id});
        }
    },
    mutations: {
        setContractors(state, data) {
            state.contractors = data;
        },
        clearContractors(state) {
            state.contractors = [];
        }
    }
}
